module.exports = __webpack_public_path__ + "static/media/letterhead.fe242b03.jpg";